import type { Environment } from 'config/environment'

import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import { buildTrackingData } from './buildTrackingData'
import { GraphQLClient } from './graphql/provider'

let globalEnvironment: Environment | null = null

export const init = (environment: Environment) => {
  globalEnvironment = environment
}

export const track = async (
  graphQLClient: GraphQLClient | null,
  label: string,
  data: object = {}
) => {
  if (!graphQLClient) {
    return null
  }

  const trackingData = await buildTrackingData(graphQLClient)

  if (!trackingData) {
    return
  }

  const { userEmail, userId, companyName, companyId } = trackingData

  return ApiClient().post('/frontend_events', {
    event_type: label,
    event_data: {
      ...data,
      release: globalEnvironment?.releaseVersion,
      location: window.location.href,
      user: userEmail,
      email: userEmail,
      user_id: userId,
      company: companyName,
      company_id: companyId,
    },
  })
}
